module.exports = __webpack_public_path__ + "static/media/9.c151b457.jpg";